import React from 'react';
import './todayNews.scss';
import Category from '../../category/Category';
import DateText from '../../texts/dateText/DateText';
import ReadMore from '../../buttons/readMore/ReadMore';
import { useNavigate } from 'react-router-dom';
import { IUpdteTodayNews } from '../../../tpyes/comment';

interface ITodayNews {
  news : IUpdteTodayNews;
}

const TodayNews = ({ news }: ITodayNews ) => {
  const {latest_news} = news;
  const navigate = useNavigate();

  return (
    <div className="main-today-container">
      <img src={latest_news.image || 'default_image_path'} alt="today 이미지" className="today-news-img"  onClick={() => {
          navigate(`/news/${latest_news.id}`);
        }}/>
      <div className='category-box'>
        <Category value={news.name} />
      </div>

      <div
        className="sub-title"
        onClick={() => {
          navigate(`/news/${latest_news.id}`);
        }}
      >
        {latest_news.title}
      </div>
      <div className="detail">{latest_news.subtitle}</div>

      <div className="date-box flex">
        <DateText date={latest_news.published_at || latest_news.updated_at || 'default_date'} />
      </div>

      <div className="btn-box">
        <ReadMore id={+latest_news.id!} />
      </div>
    </div>
  );
};

export default TodayNews;
